// Marks the table unit with its density, so the stylesheet sets the cell padding. Every View module calls
// it; writing the same attribute twice is harmless. The unit's own ref attaches after its children's layout
// effects run, so the unit is found from a node the caller renders inside it.

import { useLayoutEffect } from 'react'

const unitOf = (anchor, refs) => {
  const node = anchor && anchor.current
  const found = node && node.closest ? node.closest('.me-table-unit') : null
  return found || (refs && refs.unit && refs.unit.current) || null
}

/**
 * @param {{current: ?HTMLElement}} anchor a node inside the table unit
 * @param {?{unit: {current: ?HTMLElement}}} refs the context's refs
 * @param {import('../types').Density} density
 */
export const useDensityAttribute = (anchor, refs, density) => {
  useLayoutEffect(() => {
    const unit = unitOf(anchor, refs)
    if (unit && density && unit.getAttribute('data-density') !== density)
      unit.setAttribute('data-density', density)
  })
}
